import { EngageType } from '@cibo/core'
import { ExtendedTheme } from '@cibo/ui'
import { Typography, useTheme } from '@mui/material'
import { path } from 'ramda'
import { useTranslation } from 'react-i18next'
import { UserProgramCardStatus } from '../UserProgramCardTypes'

const BANNER_STATUS_COLOR = {
  actionNeeded: ['warning', 'light'],
  enrolling: ['warning', 'light'],
  eligible: ['info', 'light'],
  ineligible: ['future', 'dark'],
  enrolled: ['success', 'light'],
}

type UserProgramCardBannerProps = {
  engageType?: EngageType
  userProgramStatus: UserProgramCardStatus
}

export const UserProgramCardBanner = ({
  engageType,
  userProgramStatus,
}: UserProgramCardBannerProps) => {
  const { palette } = useTheme<ExtendedTheme>()
  const { t } = useTranslation('impact/UserProgramsListBanner')

  const paletteColor = BANNER_STATUS_COLOR[userProgramStatus]

  return (
    <Typography
      color="primary.contrastText"
      variant="overline"
      sx={{
        backgroundColor: path(paletteColor, palette) as string,
        paddingInline: 1,
        display: 'block',
      }}
    >
      {t(`bannerStatus_${engageType}_${userProgramStatus}`)}
    </Typography>
  )
}
